// Names of events are prefixes with EVENT_
export const EVENT_BUTTON_INTERACTION = 'buttonInteraction'
export const EVENT_CHECKBOX_INTERACTION = 'checkboxInteraction'
export const EVENT_INPUT_INTERACTION = 'inputInteraction'
export const EVENT_LINK_INTERACTION = 'linkInteraction'
export const EVENT_SELECT_INTERACTION = 'selectInteraction'
export const EVENT_SLIDER_INTERACTION = 'sliderInteraction'

// The property that an event can have is prefixed with EVENT_PROPERTY
export const EVENT_PROPERTY_ACTION = 'action'
export const EVENT_PROPERTY_DESCRIPTOR = 'descriptor'
export const EVENT_PROPERTY_UI_CONTEXT = 'ui_context'

// The action that an interactable can have as a property
// is prefixed with EVENT_ACTION_
export const EVENT_ACTION_BLURRED = 'Blurred'
export const EVENT_ACTION_CHANGED = 'Changed'
export const EVENT_ACTION_CHECKED = 'Checked'
export const EVENT_ACTION_CLICKED = 'Clicked'
export const EVENT_ACTION_FOCUSED = 'Focused'
export const EVENT_ACTION_UNCHECKED = 'Unchecked'

export type EventType =
  | typeof EVENT_BUTTON_INTERACTION
  | typeof EVENT_INPUT_INTERACTION
  | typeof EVENT_SELECT_INTERACTION
  | typeof EVENT_SLIDER_INTERACTION
  | typeof EVENT_CHECKBOX_INTERACTION
  | typeof EVENT_LINK_INTERACTION

export type EventActionType =
  | typeof EVENT_ACTION_BLURRED
  | typeof EVENT_ACTION_CHANGED
  | typeof EVENT_ACTION_CLICKED
  | typeof EVENT_ACTION_FOCUSED
  | typeof EVENT_ACTION_CHECKED
  | typeof EVENT_ACTION_UNCHECKED
